import * as React from "react";
import { cn } from "../../lib/utils";
import { Divider } from "../divider";
import type { ListDividerProps } from "./list-types";

const INSET_CLASSES = {
	icon: "pl-[56px]",
	avatar: "pl-[72px]",
	custom: "pl-4",
} as const;

const ListDividerImpl = React.forwardRef<HTMLLIElement, ListDividerProps>(
	({ className, inset = false, insetType = "avatar", ...props }, ref) => {
		const insetClass = inset ? INSET_CLASSES[insetType] : "";

		return (
			<li
				ref={ref}
				role="presentation"
				className={cn("w-full bg-transparent list-none", insetClass, className)}
				{...props}
			>
				<Divider
					variant="full-bleed"
					className="w-full"
					animate={false}
					decorative
				/>
			</li>
		);
	},
);

ListDividerImpl.displayName = "ListDivider";

export const ListDivider = React.memo(ListDividerImpl);
export type { ListDividerProps };
